import request from '@/utils/request'

// 列表
export function getBillExport(data) {
  return request({
    url: "/api/biz/org-bill/export",
    method: "post",
    data,
    responseType: "blob"
  });
}
//  企业机构
export function getEnList(params) {
  return request({
    url: "/api/admin/en/list",
    method: "GET",
    params
  });
}
/* 产品询价留言板 */
export function getProductInquiryMessagetList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/message-board-list",
    method: "GET",
    params
  });
}
// 产品询价提交留言
export function getProductInquiryMessagetCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/create-message-board",
    method: "post",
    data
  });
}
/* 产品报价留言板 */
export function getProductOfferMessagetList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/message-board-list",
    method: "GET",
    params
  });
}
// 产品报价提交留言
export function getProductOfferMessagetCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/create-message-board",
    method: "post",
    data
  });
}
/* 服务询价留言板 */
export function getServiceInquiryMessagetList(params) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/message-board-list",
    method: "GET",
    params
  });
}
// 服务询价提交留言
export function getServiceInquiryMessagetCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/create-message-board",
    method: "post",
    data
  });
}
/* 服务报价留言板 */
export function getServiceOfferMessagetList(params) {
  return request({
    url: "/api/enterprise/service-offer/message-board-list",
    method: "GET",
    params
  });
}
// 服务报价提交留言
export function getServiceOfferMessagetCreate(data) {
  return request({
    url: "/api/enterprise/service-offer/create-message-board",
    method: "post",
    data
  });
}
/* 项目管理 */
/* 项目列表 */
export function getEnterpriseProjectList(params) {
  return request({
    url: "/api/enterprise/project/list",
    method: "GET",
    params
  });
}
// 收藏
export function getEnterpriseEnCollectionHandle(data) {
  return request({
    url: "/api/enterprise/en_collection/handle",
    method: "post",
    data
  });
}

// 详情
export function getEnterpriseProjectDetail(params) {
  return request({
    url: "/api/enterprise/project/detail",
    method: "GET",
    params
  });
}

// 删除
export function getEnterpriseProjectDelete(data) {
  return request({
    url: "/api/enterprise/project/delete",
    method: "post",
    data
  });
}

// 编辑
export function getEnterpriseProjectUpdate(data) {
  return request({
    url: "/api/enterprise/project/update",
    method: "post",
    data
  });
}
// 创建
export function getEnterpriseProjectCreate(data) {
  return request({
    url: "/api/enterprise/project/create",
    method: "post",
    data
  });
}
//  地区
export function getAreaList(params) {
  return request({
    url: "/api/enterprise/region/getJson",
    method: "GET",
    params
  });
}
// 地区查询
export function getRegionList(params) {
  return request({
    url: "/api/enterprise/region/get",
    method: "GET",
    params
  });
}
// 分类查询
export function getClassifyList(params) {
  return request({
    url: "/api/enterprise/classify/get",
    method: "GET",
    params
  });
}
// 所有分类（层级）
export function getAllClassifyList(params) {
  return request({
    url: "/api/enterprise/classify/getAllClassify",
    method: "GET",
    params
  });
}

// 新增子类
export function getAddClassify(data) {
  return request({
    url: "/api/enterprise/classify/addClassify",
    method: "post",
    data
  });
}
// 库同步（数组）
export function getSyncInquiryProductArray(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/sync-product-array",
    method: "post",
    data
  });
}
// 同步库（文本）
export function getSyncInquiryProductText(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/sync-product-text",
    method: "post",
    data
  });
}
/* 产品管理 */
// 产品询价管理列表
export function getProductInquiryList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/list",
    method: "GET",
    params
  });
}
// 企业产品专属库与系统基础库查询
export function getProductList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/query-product",
    method: "GET",
    params
  });
}
// 企业产品发布
export function getProductInquiryRelease(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/release",
    method: "post",
    data
  });
}
// 企业产品询价详情
export function getProductInquiryDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/detail",
    method: "GET",
    params
  });
}
// 报价总价统计
export function getOfferTotalStatistics(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/offer-total-statistics",
    method: "GET",
    params
  });
}
// 结果汇总
export function inquiryProductReportExportAllPage(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/inquiry-product-report-export-data",
    method: "get",
    params,
  });
}
// 企业产品询价报告
export function getProductInquiryReport(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/report",
    method: "GET",
    params
  });
}
// 企业产品询价详情下的报价列表
export function getProductInquiryBrieflyList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/offer-list-by-detail",
    method: "GET",
    params
  });
}
// 企业产品询价详情下的报价详情
export function getProductInquiryOfferDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/product-offer-detail",
    method: "GET",
    params
  });
}
// // 企业产品询价详情下的报价详情
// export function getProductInquiryOfferDetail(params) {
//   return request({
//     url: "/api/enterprise/enterprise-product-inquiry/offer-detail-by-detail",
//     method: "GET",
//     params
//   });
// }
// 企业产品询价新增
export function getProductInquiryCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/create",
    method: "post",
    data
  });
}
// 企业产品询价编辑
export function getProductInquiryUpdate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/update",
    method: "post",
    data
  });
}
// 企业产品询价删除
export function getProductInquiryDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/delete",
    method: "post",
    data
  });
}
// 企业产品询价暂存
export function getProductTemporaryStorage(data) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/temporary-storage",
    method: "post",
    data
  });
}
// 企业产品详情下的分类数量的企业列表
export function getProductEnterpriseList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-inquiry/enterprise-list-by-classify",
    method: "GET",
    params
  });
}
// 企业产品报价简要（询价详情中展示）
export function getProductInquiryBrieflyDetail(params) {
  return request({
    url: "/api/admin/enterprise-product-inquiry/briefly-by-detail",
    method: "GET",
    params
  });
}

// 查询技术标准
export function getProductFindStandard(params) {
  return request({
    url: "/api/admin/product/findStandard",
    method: "GET",
    params
  });
}

// 查询产品代码
export function getProductFindCode(params) {
  return request({
    url: "/api/admin/product/findCode",
    method: "GET",
    params
  });
}

// 企业伙伴列表
export function getPartnerList(params) {
  return request({
    url: "/api/admin/partner/list",
    method: "GET",
    params
  });
}

// 统计产品相关的企业数量
export function getPartnerStatisticsProduct(params) {
  return request({
    url: "/api/admin/partner/statisticsProduct",
    method: "GET",
    params
  });
}


/* 产品报价 */
// 产品报价列表
export function getProductOfferList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/list",
    method: "GET",
    params
  });
}
// 企业产品报价详情
export function getProductOfferDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/detail",
    method: "GET",
    params
  });
}
// 企业产品报价新增
export function getProductOfferCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/create",
    method: "post",
    data
  });
}
// 企业产品报价编辑
export function getProductOfferUpdate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/update",
    method: "post",
    data
  });
}
// 企业产品报价删除
export function getProductOfferDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/delete",
    method: "post",
    data
  });
}
// 企业产品报价暂存
export function getOfferTemporaryStorage(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/temporary-storage",
    method: "post",
    data
  });
}
// 是否有暂存
export function getGetProductTemporaryStorage(params) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/get-offer-by-me",
    method: "GET",
    params
  });
}

// 企业产品报价询价详情
export function getProductOfferDetailInquiry(params) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/inquiry-detail",
    method: "GET",
    params
  });
}

// 更新盖章版报价表
export function getProductUpdateSealUrl(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/update-seal-url",
    method: "post",
    data
  });
}

// 企业产品报价简要
export function getProductOfferBriefly(params) {
  return request({
    url: "/api/admin/enterprise-product-offer/briefly",
    method: "GET",
    params
  });
}

// 企业产品报价详情下的报价列表
export function getProductOfferDetailList(params) {
  return request({
    url: "/api/admin/enterprise-product-offer/list-by-detail",
    method: "GET",
    params
  });
}

/* 企业产品库 */
// 产品基础库
export function getEnterpriseAllProductList(params) {
  return request({
    url: "/api/enterprise/product/list",
    method: "GET",
    params
  });
}
// 企业产品列表
export function getEnterpriseProductList(params) {
  return request({
    url: "/api/enterprise/enterprise-product/list",
    method: "GET",
    params
  });
}

// 详情
export function getEnterpriseProductDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-product/detail",
    method: "GET",
    params
  });
}

// 删除
export function getEnterpriseProductDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-product/delete",
    method: "post",
    data
  });
}

// 添加
export function getEnterpriseProductCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-product/create",
    method: "post",
    data
  });
}
// 编辑
export function getEnterpriseProductUpdate(data) {
  return request({
    url: "/api/enterprise/enterprise-product/update",
    method: "post",
    data
  });
}
// 库同步（数组）
export function getSyncProductArray(data) {
  return request({
    url: "/api/enterprise/enterprise-product/sync-product-array",
    method: "post",
    data
  });
}
// 同步库（文本）
export function getSyncProductText(data) {
  return request({
    url: "/api/enterprise/enterprise-product/sync-product-text",
    method: "post",
    data
  });
}
/* 企业产品供应 */
// 企业产品供应列表
export function getEnterpriseProductSupplyList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-supply/list",
    method: "GET",
    params
  });
}

// 详情
export function getEnterpriseProductSupplyDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-product-supply/detail",
    method: "GET",
    params
  });
}

// 删除
export function getEnterpriseProductSupplyDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-product-supply/delete",
    method: "post",
    data
  });
}

// 添加
export function getEnterpriseProductSupplyCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-supply/create",
    method: "post",
    data
  });
}
// 发布
export function getEnterpriseProductSupplyRelease(data) {
  return request({
    url: "/api/enterprise/enterprise-product-supply/release",
    method: "post",
    data
  });
}
// 编辑
export function getEnterpriseProductSupplyUpdate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-supply/update",
    method: "post",
    data
  });
}
// 暂存
export function getProductSupplyTemporaryStorage(data) {
  return request({
    url: "/api/enterprise/enterprise-product-supply/temporary-storage",
    method: "post",
    data
  });
}
/* 服务能力 */
// 企业服务列表
export function getEnterpriseServiceList(params) {
  return request({
    url: "/api/enterprise/enterprise-service/list",
    method: "GET",
    params
  });
}

// 详情
export function getEnterpriseServiceDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-service/detail",
    method: "GET",
    params
  });
}

// 删除
export function getEnterpriseServiceDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-service/delete",
    method: "post",
    data
  });
}

// 编辑
export function getEnterpriseServiceUpdate(data) {
  return request({
    url: "/api/enterprise/enterprise-service/update",
    method: "post",
    data
  });
}
// 添加
export function getEnterpriseServiceCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-service/create",
    method: "post",
    data
  });
}
/* 企业服务询价 */
// 企业服务询价列表
export function getEnterpriseServiceInquiryList(params) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/list",
    method: "GET",
    params
  });
}

// 详情
export function getEnterpriseServiceInquiryDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/detail",
    method: "GET",
    params
  });
}
// 报告
export function getEnterpriseServiceInquiryReport(params) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/report",
    method: "GET",
    params
  });
}
// 删除
export function getEnterpriseServiceInquiryDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/delete",
    method: "post",
    data
  });
}

// 编辑
export function getEnterpriseServiceInquiryUpdate(data) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/update",
    method: "post",
    data
  });
}
// 新增
export function getEnterpriseServiceInquiryCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/create",
    method: "post",
    data
  });
}
// 暂存
export function getServiceInquiryTemporaryStorage(data) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/temporary-storage",
    method: "post",
    data
  });
}
// 发布
export function getEnterpriseServiceInquiryRelease(data) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/release",
    method: "post",
    data
  });
}
// 简要
export function getEnterpriseServiceInquiryBriefly(params) {
  return request({
    url: "/api/admin/enterprise-service-inquiry/briefly",
    method: "GET",
    params
  });
}

// 简要
export function getServiceInquiryList(params) {
  return request({
    url: "/api/admin/enterprise-service-inquiry/service-offer-list-detail",
    method: "GET",
    params
  });
}

/* 服务报价管理 */
// 服务报价列表
export function getServiceOfferList(params) {
  return request({
    url: "/api/enterprise/service-offer/list",
    method: "GET",
    params
  });
}

// 详情
export function getServiceOfferDetail(params) {
  return request({
    url: "/api/enterprise/service-offer/detail",
    method: "GET",
    params
  });
}
// 服务报价详情
export function getInquiryServiceOfferDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/service-offer-detail",
    method: "GET",
    params
  });
}

// 删除
export function getServiceOfferDelete(data) {
  return request({
    url: "/api/enterprise/service-offer/delete",
    method: "post",
    data
  });
}
// 新增
export function getServiceOfferCreate(data) {
  return request({
    url: "/api/enterprise/service-offer/create",
    method: "post",
    data
  });
}// 编辑
export function getServiceOfferUpdate(data) {
  return request({
    url: "/api/enterprise/service-offer/update",
    method: "post",
    data
  });
}
// 暂存
export function getServiceOfferTemporaryStorage(data) {
  return request({
    url: "/api/enterprise/service-offer/temporary-storage",
    method: "post",
    data
  });
}
// 暂存详情
export function getServiceofferByMe(params) {
  return request({
    url: "/api/enterprise/service-offer/get-offer-by-me",
    method: "GET",
    params
  });
}

// 是否有暂存
export function getGetTemporaryStorage(params) {
  return request({
    url: "/api/enterprise/service-offer/get-temporary-storage",
    method: "GET",
    params
  });
}
// 详情-服务询价详情
export function getServiceOfferInquiryDetail(params) {
  return request({
    url: "/api/enterprise/service-offer/service-inquiry-detail",
    method: "GET",
    params
  });
}
// 详情
export function getServiceOfferDetailInquiry(params) {
  return request({
    url: "/api/admin/service-offer/detail-by-inquiry",
    method: "GET",
    params
  });
}


/* 企业服务供应 */
// 企业服务供应列表
export function getEnterpriseServiceSupplyList(params) {
  return request({
    url: "/api/enterprise/enterprise-service-supply/list",
    method: "GET",
    params
  });
}

// 详情
export function getEnterpriseServiceSupplyDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-service-supply/detail",
    method: "GET",
    params
  });
}

// 删除
export function getEnterpriseServiceSupplyDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-service-supply/delete",
    method: "post",
    data
  });
}

// 编辑
export function getEnterpriseServiceSupplyUpdate(data) {
  return request({
    url: "/api/enterprise/enterprise-service-supply/update",
    method: "post",
    data
  });
}
// 新增
export function getEnterpriseServiceSupplyCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-service-supply/create",
    method: "post",
    data
  });
}
// 暂存
export function getServiceSupplyTemporaryStorage(data) {
  return request({
    url: "/api/enterprise/enterprise-service-supply/temporary-storage",
    method: "post",
    data
  });
}
// 发布
export function getEnterpriseServiceSupplyRelease(data) {
  return request({
    url: "/api/enterprise/enterprise-service-inquiry/release",
    method: "post",
    data
  });
}


// 采购 -- 二手物资模块接口

// 新增
export function addSecondHand(data) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/create",
    method: "post",
    data
  });
}
// 删除
export function deleteSecondHand(data) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/delete",
    method: "post",
    data
  });
}
// 更新
export function updateSecondHand(data) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/update",
    method: "post",
    data
  });
}
// 二手物资列表
export function getSecondHandList(params) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/list",
    method: "GET",
    params
  });
}
// 参与二手物资列表
export function getSecondHandListByMe(params) {
  return request({
    url: "/api/enterprise/second-hand-product-offer/list",
    method: "GET",
    params
  });
}
// 详情
export function getSecondHandDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/detail",
    method: "get",
    params
  });
}

// 报价详情
export function getSecondHandPriceDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/offer-detail",
    method: "get",
    params
  });
}
// 报价报告
export function getSecondHandReportDetail(params) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/report",
    method: "get",
    params
  });
}
// 报价列表
export function getSecondHandPriceList(params) {
  return request({
    url: "/api/enterprise/enterprise-second-hand-product-inquiry/offer-list",
    method: "get",
    params
  });
}

// 新增报价
export function createSecondHandPrice(data) {
  return request({
    url: "/api/enterprise/second-hand-product-offer/create",
    method: "post",
    data
  });
}

// 更新报价
export function updateSecondHandPrice(data) {
  return request({
    url: "/api/enterprise/second-hand-product-offer/update",
    method: "post",
    data
  });
}

// 获取我的报价
export function SecondHandPriceByMe(params) {
  return request({
    url: "/api/enterprise/second-hand-product-offer/get-offer-by-me",
    method: "get",
    params
  });
}

// 确认最优报价
export function optimal(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/excellent",
    method: "POST",
    data
  });
}

// 给报价评分
export function rateScore(data) {
  return request({
    url: "/api/enterprise/enterprise-product-offer/score",
    method: "POST",
    data
  });
}

// 确认批量导入数据到库
export function productMultipleImport(data) {
  return request({
    url: "/api/enterprise/enterprise-product/batch-create",
    method: "POST",
    data
  });
}

// 套餐列表
export function getPackageList(params) {
  return request({
    url: "/api/enterprise/cerdit/package/list",
    method: "get",
    params
  });
}

// 套餐下单
export function createPayOrder(params) {
  return request({
    url: "/api/enterprise/package/order/create",
    method: "POST",
    params
  });
}

// 拉起支付
export function pullPayQrCode(data) {
  return request({
    url: "/api/enterprise/pay/createBuyCerditPackageQrcode",
    method: "POST",
    data
  });
}

// 融资贷款
export function loanAmountAdd(data) {
  return request({
    url: "/api/enterprise/loan_amount/add",
    method: "POST",
    data
  });
}

export function loanAmountUpdate(data) {
  return request({
    url: "/api/enterprise/loan_amount/update",
    method: "POST",
    data
  });
}

export function loanAmountDelete(data) {
  return request({
    url: "/api/enterprise/loan_amount/delete",
    method: "POST",
    data
  });
}

export function loanAmountList(params) {
  return request({
    url: "/api/enterprise/loan_amount/my_list",
    method: "get",
    params
  });
}



export function getLoanAmount(params) {
  return request({
    url: "/api/enterprise/loan_amount/get",
    method: "get",
    params
  });
}



export function enOtherUserList(params) {
  return request({
    url: "/api/enterprise/en_other/user_list",
    method: "get",
    params
  });
}

export function verifyListingStatus(data) {
  return request({
    url: "/api/enterprise/loan_amount/verify_listing_status",
    method: "POST",
    data
  });
}

// 融资贷款信息采集列表
export function loanAmountApplyList(params) {
  return request({
    url: "/api/enterprise/loan_amount_apply/list",
    method: "get",
    params
  });
}

// 融资贷款信息采集列表导出
export function loanAmountApplyExport(params) {
  return request({
    url: "/api/enterprise/loan_amount_apply/export",
    method: "get",
    params,
    responseType: "blob"
  });
}

// 我的订单
export function payOrderList(params) {
  return request({
    url: "/api/enterprise/order/list",
    method: "get",
    params
  });
}

// 产品价格表创建
export function enterpriseProductPpriceCreate(data) {
  return request({
    url: "/api/enterprise/enterprise-product-price/create",
    method: "POST",
    data
  });
}

// 产品价格表列表
export function enterpriseProductPpriceList(params) {
  return request({
    url: "/api/enterprise/enterprise-product-price/list",
    method: "get",
    params
  });
}


// 产品价格表 删除
export function enterpriseProductPpriceDelete(data) {
  return request({
    url: "/api/enterprise/enterprise-product-price/delete",
    method: "POST",
    data,
  });
}


// 设备租赁列表
export function deviceLeaseList(params) {
  return request({
    url: "/api/enterprise/device_lease/my_list",
    method: "get",
    params
  });
}

// 设备租赁删除
export function deviceLeaseDelete(data) {
  return request({
    url: "/api/enterprise/device_lease/delete",
    method: "POST",
    data,
  });
}

// 设备租赁更新
export function deviceLeaseUpdate(data) {
  return request({
    url: "/api/enterprise/device_lease/update",
    method: "POST",
    data,
  });
}

// 设备租赁创建
export function deviceLeaseAdd(data) {
  return request({
    url: "/api/enterprise/device_lease/add",
    method: "POST",
    data,
  });
}

// 设备租赁详情
export function deviceLeaseDetail(params) {
  return request({
    url: "/api/enterprise/device_lease/get",
    method: "get",
    params,
  });
}

// 更新租赁上下架状态
export function deviceVerifyListingStatus(data) {
  return request({
    url: "/api/enterprise/device_lease/verify_listing_status",
    method: "POST",
    data
  });
}

// 设备租赁采集列表
export function deviceApplyList(params) {
  return request({
    url: "api/enterprise/device_lease_apply/list",
    method: "get",
    params
  });
}

// 设备租赁采集列表导出
export function deviceApplyExport(params) {
  return request({
    url: "api/enterprise/device_lease_apply/export",
    method: "get",
    params,
    responseType: "blob"
  });
}


// 其他服务列表
export function otherServiceList(params) {
  return request({
    url: "/api/enterprise/other_service/my_list",
    method: "get",
    params
  });
}
// 其他服务创建
export function otherServiceAdd(data) {
  return request({
    url: "/api/enterprise/other_service/add",
    method: "POST",
    data,
  });
}
// 其他服务更新
export function otherServiceUpdate(data) {
  return request({
    url: "/api/enterprise/other_service/update",
    method: "POST",
    data,
  });
}
// 其他服务删除
export function otherServiceDelete(data) {
  return request({
    url: "/api/enterprise/other_service/delete",
    method: "POST",
    data,
  });
}
// 其他服务详情
export function otherServiceDetail(params) {
  return request({
    url: "/api/enterprise/other_service/get",
    method: "get",
    params,
  });
}

// 更新其他服务上下架状态
export function otherVerifyListingStatus(data) {
  return request({
    url: "/api/enterprise/other_service/verify_listing_status",
    method: "POST",
    data
  });
}

// 其他服务采集列表
export function otherApplyList(params) {
  return request({
    url: "api/enterprise/other_service_apply/list",
    method: "get",
    params
  });
}

// 其他服务采集列表导出
export function otherApplyExport(params) {
  return request({
    url: "api/enterprise/other_service_apply/export",
    method: "get",
    params,
    responseType: "blob"
  });
}

// 司法查询--企业查询
export function queryCompanyInfo(data) {
  return request({
    url: "api/enterprise/cerdit/query/company",
    method: "POST",
    data
  });
}

// 根据ID 获取 查询结果
export function getCompanyInfo(params) {
  return request({
    url: "/api/enterprise/cerdit/result/detail",
    method: "get",
    params
  });
}

// 查询个人授权 图形验证码
export function cerditQueryCaptcha(params) {
  return request({
    url: "/api/enterprise/cerdit/query/captcha",
    method: "GET",
    params
  });
}

// 查询个人授权 获取短信验证码
export function sendQuerySmsCode(data) {
  return request({
    url: "/api/enterprise/cerdit/query/send_query_sms_code",
    method: "POST",
    data
  });
}

// 获取个人授权是否有效
export function checkQueryAuth(data) {
  return request({
    url: "/api/enterprise/cerdit/query/check_query_auth",
    method: "POST",
    data
  });
}


// 开始查询个人信息
export function queryPersionInfo(data) {
  return request({
    url: "/api/enterprise/cerdit/query/person",
    method: "POST",
    data
  });
}

// 司法查询记录
export function cerditResultList(params) {
  return request({
    url: "/api/enterprise/cerdit/result/list",
    method: "GET",
    params
  });
}


// 积分转赠
export function integralByRransfer(data) {
  return request({
    url: "/api/enterprise/integral/increase-by-transfer ",
    method: "POST",
    data
  });
}
// 积分流水
export function integralStatementList(params) {
  return request({
    url: "/api/enterprise/integral/user-statement-list",
    method: "GET",
    params
  });
}

// 积分规则
export function integralRuleList(params) {
  return request({
    url: "/api/enterprise/integral/rule-list",
    method: "GET",
    params
  });
}

export function integralRuleDetail(params) {
  return request({
    url: "/api/enterprise/integral/config-detail",
    method: "GET",
    params
  });
}

// 用户积分详情
export function integralUserDetail(params) {
  return request({
    url: "/api/enterprise/integral/user-detail",
    method: "GET",
    params
  });
}


// 申请开发票
export function createInvoice(data) {
  return request({
    url: "/api/enterprise/invoice/create",
    method: "POST",
    data
  });
}


// 撤销申请
export function invoiceRevoke(data) {
  return request({
    url: "/api/enterprise/invoice/revoke",
    method: "POST",
    data
  });
}


// 发票详情
export function invoiceDetail(params) {
  return request({
    url: "/api/enterprise/invoice/detail",
    method: "GET",
    params
  });
}


// 开票记录
export function invoiceList(params) {
  return request({
    url: "/api/enterprise/invoice/list",
    method: "GET",
    params
  });
}

// 获取上一条数据
//api/enterprise/invoice/last-message-data

// 获取发票下的订单列表
export function invoiceRrderList(params) {
  return request({
    url: "/api/enterprise/invoice/order-list",
    method: "GET",
    params
  });
}

// 查询报告导出
export function exportCerditDownload(params) {
  return request({
    url: "/api/enterprise/cerdit/result/download",
    method: "GET",
    params,
    responseType: "blob"
  });
}

// 获取支付协议
export function buyAgreement(params) {
  return request({
    url: "/api/common/buy_agreement",
    method: "GET",
    params
  });
}


